import { Outlet, useLocation } from 'react-router-dom';
import Header from './Header';
import { useTheme } from '../lib/theme';

const Footer = () => {
  const year = new Date().getFullYear();

  return (
    <footer className="text-center py-10 mt-16 border-t border-brand-accent/20">
      <div className="container mx-auto">
        <p className="text-sm text-brand-text-light/60">
          &copy; {year} Agata Columbano Etsuko FCI Japanese Chin Kennel created by Bartłomiej Zawadzki
        </p>
      </div>
    </footer>
  );
};

const Layout = () => {
  const { isImperial } = useTheme();
  const { pathname } = useLocation();

  if (isImperial) {
    // Imperial: pełna szerokość, bez „pudełka". Strona główna ma hero full-bleed,
    // podstrony dostają elegancki kontener z oddechem.
    const isHome = pathname === '/';
    return (
      <div className="page-container-bg min-h-screen flex flex-col">
        <Header />
        <main className="flex-grow">
          {isHome ? <Outlet /> : (
            <div className="max-w-6xl mx-auto px-6 md:px-8 py-6 md:py-10">
              <Outlet />
            </div>
          )}
        </main>
        <Footer />
      </div>
    );
  }

  return (
    <div className="page-container-bg min-h-screen flex flex-col shadow-2xl sm:rounded-lg overflow-hidden">
      <div className="w-full max-w-7xl mx-auto border-x-2 border-brand-accent/30">
        <Header />
        <main className="flex-grow">
          <div className="max-w-6xl mx-auto my-12 p-4 md:p-8 bg-brand-bg-center/90 rounded-lg shadow-2xl backdrop-blur-sm">
            <Outlet />
          </div>
        </main>
        <Footer />
      </div>
    </div>
  );
};

export default Layout; 